var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "component-loading" }, [
      _c("i"),
      _c("div", { staticClass: "text-loading t-ct color-gray-1" }, [
        _vm._v("加载中...")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }